export enum OptionPointSales {
  'claro-credibanco' = 'claro-credibanco',
  'exito-evertec' = 'exito-evertec',
  'ninguno' = 'ninguno',
}
